
import React, { useEffect, useState } from 'react';
import './index.css';
import { Popover, Table } from 'antd';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import LoginSelector from 'views/login/login.selector';
import { convertToLocalString, MFDetailsPageURL,sortByProperty } from '__utils/common-utils';
import { useDeepCompare } from '../../hooks/use-deep-memo';
import FolioCards from './folio-cards';
import { useMediaQuery } from 'react-responsive';
import FolioOperations from './folio-operations';
import moment from 'moment';



const PortfolioGrid: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [parentTableData, setParentTableData] = useState<any[]>([]);
    const [showPortfolioDetailForScheme, setShowPortfolioDetailForScheme] = useState<any>();
    const { portfolioDetails } = propsToJS(useSelector(LoginSelector));
    
    const majorStatus = sessionStorage.getItem('majorStatus') || '';

    useEffect(() => {
        if (portfolioDetails) {
            const filteredSchemes = portfolioDetails?.portfolioSchemes
                ?.filter((portfolioScheme: any) => portfolioScheme.amountInvested > 0);
            const sortedSchemes = sortByProperty(filteredSchemes, scheme => scheme?.metaData?.schemeShortName);
            const finalSchemes = sortedSchemes?.map((scheme: any, index: number) => ({ ...scheme, key: index }));
            setParentTableData(finalSchemes);
        }
    }, [useDeepCompare(portfolioDetails)]);

    const columns = [
        {
            title: 'Scheme Name', dataIndex: 'name', key: 'name', width: 210,
            render: (text: any, record: any) => <div style={{position: 'relative'}}>
                {record?.metaData?.fundType == 'Open Ended Investment Company' && <a
                    href={!majorStatus ? MFDetailsPageURL(record.metaData) : '#'}
                    onClick={(e:any) => e.preventDefault()}
                    target='_blank'
                    >{record?.metaData?.schemeShortName}</a>}

                {record?.metaData?.fundType === 'Unlisted Closed End Investment Company' && (
                    <span>{record?.metaData?.schemeShortName || ''}</span>
                )}
                {(record?.tagToDisplay && record?.tagToDisplay !== 'none') && <>
                    <p className='redemtion-sec'> 
                        {record?.tagToDisplay === 'all' ? `Full redemption`: 'Redemption'} in progress < br /> 
                        {record?.tagToDisplay !== 'all' && record?.tagToDisplay !== 'units' && <>Amount : ₹{record?.inProgressAmount || 0} <br /></> } 
                        {record?.tagToDisplay !== 'amount' && <>Units : {record?.tagToDisplay === 'all' ? record.unitsAllocated : (record?.inProgressUnits || 0)}</>}
                    </p>
                </>
                }
                <p className='folioText'>Folio #<span>{record?.folioNo}</span></p>
                {record?.setupDate > new Date() && <p className='errorMsg'>NAV will be available from {moment(record?.setupDate).format('DD/MM/YYYY')}</p>}
            </div>
        },

        {
            title: `NAV`, dataIndex: 'todaysNAV', key: 'todaysNAV', width: 100,
            render: (text: any, record: any) => <>{ record?.setupDate > new Date() ? 'N.A' : <p> {text && convertToLocalString(text)} </p>}</>
        },
        {
            title: `NAV Date`, dataIndex: 'latestNavDateByBatch', key: 'latestNavDateByBatch', width: 100,
            render: (text: any, record: any) => <>{ record?.setupDate > new Date() ? 'N.A' : <p>{moment(text).format('DD/MM/YYYY')} </p>}</>
        },
        {
            title: 'Total Units', dataIndex: 'unitsAllocated', key: 'unitsAllocated', width: 100,
            render: (text: any) => <p>{text != null && text !== '' ? Number(text).toFixed(3) : 'N.A'}</p>
        },
        {
            title: 'Net Investment(Rs)', dataIndex: 'amountInvested', key: 'amountInvested',
            render: (text: any) => <p>{text != null && text !== '' ? convertToLocalString(Number(text)) : 'N.A'}</p>
        },
        {
            title: 'Current Value (Rs)', dataIndex: 'currentValue', key: 'currentValue', width: 100,
            render: (text: any, record: any) => <>{ record?.setupDate > new Date() ? 'N.A' : <p> {convertToLocalString(text)}</p>} </>
        },
        {
            title: `Today's change (Rs)`, dataIndex: 'todaysChange', key: 'todaysChange', width: 100,
            render: (text: any, record: any) => <>{ record?.setupDate > new Date() ? 'N.A' : <p>{record?.todaysChange ? record.todaysChange?.toFixed(2) : 0} </p>} </>
        },
        {
            title: `Absolute Change (Rs)`, dataIndex: 'absoluteChange', key: 'absoluteChange', render: (text: any, record: any) => <>{ record?.setupDate > new Date() ? 'N.A' : <p>
                {convertToLocalString(record?.returnAmount)}{record?.returnAmount!==0 && record?.returnPercentage!==0 ? <br /> : null}{record?.returnPercentage && `(${record?.returnPercentage?.toFixed(2)}%)`} 
            </p>} </>
        },
        // {
        //     title: `Annual(XIRR) Return (%)`, dataIndex: 'xirrReturn', key: 'xirrReturn',
        //     render: (text: any, record: any) => <p className={record?.xirrReturn > 0 ? 'changesUp Up' : 'changesDown Down'}>{!isNaN(text) && isFinite(text) ?  text?.toFixed(2) : 'N/A'}% </p>
        // },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            width: 80,
            render: (text: any, record: any) => {
                return (record?.metaData?.fundType == 'Open Ended Investment Company' && !(record?.setupDate > new Date())) ? <Popover content={<FolioOperations portfolioRecord={record}/>} trigger="click" placement="bottomRight">
                    {!majorStatus && <button className='portfolioDropdown'></button>}
                </Popover> : <></>
            },
        },
    ];

    const portfolioSchemeTransactionCol = [
        {
            title: '', dataIndex: 'id', key: 'id',
            render: (text: any, record: any, index: number) => <div>{index + 1}</div>
        },

        { title: `Transaction Date`, dataIndex: 'transactionDate', key: 'transactionDate',
            render: (text: any, record: any) => (
                <p>{text ? moment(text).format('DD/MM/YYYY') : 'N/A'}</p>
            )
        },
        { title: 'Transaction type', dataIndex: 'transactionType', key: 'transactionType' },
        {
            title: 'Amount', dataIndex: 'amount', key: 'amount', 
            render: (text: any, record: any) => (
                <p>{`${record.type === 'Redemption' ? '-' : '+'}${text != null ? convertToLocalString(text) : '0'}`}</p>
            )
        },
        {
            title: 'Units', dataIndex: 'units', key: 'units', 
            render: (text: any, record: any) => (
                <p>{`${record.type === 'Redemption' ? '-' : '+'}${text != null ? (+text).toFixed(2) : '0.00'}`}</p>
            )
        },
        {
            title: `NAV`, dataIndex: 'nav', key: 'nav',
            render: (text: any, record: any) => (
                <p>{text != null ? (+text).toFixed(2) : '0.00'}</p>
            )
        },
        { title: `Folio Number`, dataIndex: 'folioNo', key: 'folioNo' },

    ];



    return <div>
        {
            showPortfolioDetailForScheme ?
                <div>
                    <FolioCards portfolioScheme={showPortfolioDetailForScheme} showDetail={false} />
                    <div>hello</div>
                </div> :
                !isMobile ? <Table
                    columns={columns}
                    dataSource={parentTableData}
                    rowKey={(record) => record.key}
                    pagination={false}
                    expandable={{
                        expandedRowRender: (record) => <div className='ChildTablePortfolio'>
                            <Table
                                rowKey={(index) => index}
                                columns={portfolioSchemeTransactionCol}
                                dataSource={record.portfolioSchemeTransactions}
                                pagination={false}
                            />
                        </div>
                    }}

                /> :
                    <div>{

                        portfolioDetails?.portfolioSchemes.map((portfolioScheme: any, index: number) => (
                            <div key={index}>
                                <FolioCards portfolioScheme={portfolioScheme} showDetail={true} />
                                { (portfolioScheme?.metaData?.fundType === 'Open Ended Investment Company' && !(portfolioScheme?.setupDate > new Date())) && <FolioOperations portfolioRecord={portfolioScheme}/>}
                            </div>
                        ))}
                    </div>

        }

     
    </div>
};

export default PortfolioGrid;

